import React from 'react';
import Layout from '../../../../components/Layout/Layout';
import DashboardWidget from '../../../../components/Widget/DashboardWidget';
import { Box, Flex } from 'rebass';
import NoticesSentWidget from '../../../../components/Widget/NoticesSentWidget';

type AdminDashboardProps = Record<string, never>;

/**
 * @component Used for assemblies page
 */
function Dashboard(props: AdminDashboardProps): JSX.Element {
  return (
    <Layout>
      <Flex
        flexGrow={1}
        sx={{
          overflow: 'auto',
          padding: '20px',
        }}
        flexDirection="row"
      >
        <Box
          flexGrow={1}
          sx={{
            display: 'grid',
            gridTemplateColumns: [
              'repeat(1, 1fr)', // 1 column
              'repeat(1, 1fr)', // 1 column
              'repeat(2, 1fr)', // 2 columns
              'repeat(3, 1fr)', // 3 columns
            ],
            gridAutoRows: 'calc(50% - 10px)',
            gridGap: '20px',
          }}
        >
          <DashboardWidget
            sx={{
              gridColumn: [
                '1 / 2', // 1 column
                '1 / 2', // 1 column
                '1 / 4', // 2 columns
                '1 / 4', // 3 columns
              ],
            }}
            title="Notices Sent"
            subtitle="by sender by month"
            component={NoticesSentWidget}
          />
        </Box>
      </Flex>
    </Layout>
  );
}

export default Dashboard;
